import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./register.css";
import './login.css';
import Logo from "@/assets/imgs/logo.png"
import nocheck from "@/assets/imgs/check_signin.png";
import check from "@/assets/imgs/check_true_signin.png";
import PhoneInput from "react-phone-input-2";
import toast from "react-hot-toast";
import bcrypt from "bcryptjs-react";
import { useRegister, useLoginUsuario } from "@/hooks/useAuth";
import { useAuth } from "@/_zustand/auth";
import { cleanRut } from "@/lib";
import { guardarSesion } from "@/lib/sesionTokens";

export const SignIn =() => {
  const navigate = useNavigate();
  const sendRegister = useRegister();
  // CA-20: auto-login encadenado tras el registro — usa el mismo emisor de
  // sesión real que /login (loginUsuario), no el setUserAuth/setPin sin token
  // que dejaba al usuario "authed" sin ninguna sesión real.
  const sendLogin = useLoginUsuario();
  const { setSesionAuth } = useAuth();
  const [countryName, setCountryName] = useState("");

  //Tipo_id = 2 ==> cliente
  //estado_id = 1 ==> activo 
  const [formData, setFormData] = useState({
  usuario_nombre: '',
   usuario_apellido: '', 
   usuario_rut: '',
   usuario_correo: '', 
   usuariotipo_id:2,
   usuario_pass: '',
   usuario_telefono:'',
   usuario_country:'',
   estado_id: 1,
   usuario_device:"WEB",
   usuario_token:":::token:::"
  });

  const [passwordValidations, setPasswordValidations] = useState({
    minLength: false,
    hasUpperLower: false,
    hasNumber: false,
  });

  const validatePassword = (password) => {
    const validations = {
      minLength: password.length >= 8,
      hasUpperLower: /[a-z]/.test(password) && /[A-Z]/.test(password),
      hasNumber: /\d/.test(password),
    };
    setPasswordValidations(validations);
  };

  const handlePhoneChange = (value, data) => {
    // Actualizar el estado para guardar el número de teléfono completo
    setFormData(prevData => ({
        ...prevData,
        usuario_telefono: "+"+value,
    }));
  
    // Actualizar el nombre del país si es necesario
    setCountryName(data.name); 
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "usuario_pass") {
      validatePassword(value);
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (sendRegister.isLoading || sendLogin.isLoading) return; // CA-37

    // CA-20bis: el hashing del registro NO se toca sin confirmación de backend
    // (PA-9) — se conserva tal cual. La contraseña en texto plano se captura
    // aparte para el auto-login encadenado (CA-20), que sí usa loginUsuario
    // (texto plano + bcrypt.compare server-side, CA-15).
    const passwordOriginal = formData.usuario_pass;
    let password = bcrypt.hashSync(formData.usuario_pass, 10);
    let passwordHashed = password.replace(/^\$2b(.+)$/i, '$2y$1');

    const correo = formData.usuario_correo;
    const rutNormalizado = cleanRut(formData.usuario_rut);

    const payload = {
      ...formData,
      usuario_pass: passwordHashed,
      usuario_country: countryName || "Chile",
      usuario_rut: rutNormalizado,
    };

    sendRegister.mutateAsync(payload)
      .then((resp) => {
        if (resp.status == 'error') {
          toast.error(resp.message);
          return;
        }

        // CA-20: auto-login encadenado. Si falla, el usuario NO queda
        // marcado como autenticado (prohibido el estado viejo: authed sin
        // token real) — se lo informa y se lo lleva a /login con el correo
        // precargado.
        sendLogin.mutateAsync({
          usuario_correo: correo,
          usuario_pass: passwordOriginal,
          usuario_device: 'WEB',
        })
          .then((loginResp) => {
            if (loginResp.status == 'error') {
              toast.success("Cuenta creada correctamente");
              toast.error("Tu cuenta se creó, inicia sesión para continuar");
              navigate('/login', { state: { correo } });
              return;
            }

            guardarSesion({
              accessToken: loginResp.accessToken,
              refreshToken: loginResp.refreshToken,
            });
            setSesionAuth(loginResp.user);
            toast.success("Cuenta creada correctamente");
            const homePath = localStorage.getItem('companyHome') || '/';
            navigate(homePath);
          })
          .catch(() => {
            toast.success("Cuenta creada correctamente");
            toast.error("Tu cuenta se creó, inicia sesión para continuar");
            navigate('/login', { state: { correo } });
          });
      })
      .catch(() => {
        toast.error("Ha ocurrido un error al crear la cuenta");
      });
  };

  const allPasswordsValidated = 
    passwordValidations.minLength &&
    passwordValidations.hasUpperLower &&
    passwordValidations.hasNumber;

  // Clase dinámica para el botón
  const buttonClassName = `register-button ${allPasswordsValidated ? 'verde' : ''}`;

  return (
    <div className="login-container">
      <div className="login-left-image" />
      <div className="login-form-container">
      <img
          src={Logo}
          alt="Openmatic Logo"
          className="login-logo"
        />
          <h2 className="register-welcome">¡Te damos la bienvenida!</h2>
          <h3 className="register-title">Crea tu cuenta</h3>

          <form onSubmit={handleSubmit}>
            <div className="register-input-group">
              <input type="text" 
              name="usuario_nombre"
              placeholder="Nombre"
               required
               value={formData.usuario_nombre}
              onChange={handleChange}
                />
            </div>
            <div className="register-input-group">
              <input type="text" 
              name="usuario_apellido"
              placeholder="Apellido" 
              required
              value={formData.usuario_apellido}
              onChange={handleChange}
               />
            </div>
            <div className="register-input-group">
              <input type="email" 
              name="usuario_correo"
              placeholder="Correo" 
              required
              value={formData.usuario_correo}
              onChange={handleChange}
               />
            </div>
            <div className="register-input-group phone-group">
            <PhoneInput
                // ⭐️ Valor inicial
                value={formData.usuario_telefono}
                
                // ⭐️ Función de actualización que reemplaza el field.onChange
                onChange={handlePhoneChange} 

                // Configuraciones de estilo y país
                country={"cl"}
                enableSearch={true}
                countryCodeEditable={true}
                inputStyle={{
                    width: '100%',
                    height: '40px',
                    fontSize: '16px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    paddingLeft: '50px',
                }}
                containerStyle={{ margin: '10px 0', width: '100%' }}
                buttonStyle={{
                    border: '1px solid #ccc',
                    borderRadius: '4px 0 0 4px',
                    backgroundColor: 'white',
                }}
            />
            </div>
            <div className="register-input-group">
              <input type="text" 
              name="usuario_rut"
              placeholder="RUT/DNI" 
              required 
              value={formData.usuario_rut}
              onChange={handleChange}
              />
            </div>
            <div className="register-input-group">
              <input type="password" 
              name="usuario_pass"
              placeholder="Contraseña" 
              required 
              value={formData.usuario_pass}
              onChange={handleChange}
              />
            </div>

            <ul className="register-password-rules">
              <li><img src={passwordValidations.minLength ? check : nocheck} alt="check" className="check-icon" /> Contener 8 caracteres o más</li>
              <li><img src={passwordValidations.hasUpperLower ? check : nocheck} alt="check" className="check-icon" /> Utilizar mayúsculas y minúsculas</li>
              <li><img src={passwordValidations.hasNumber ? check : nocheck} alt="check" className="check-icon" /> Incluir 1 número por lo menos</li>
            </ul>

            <button
              className={buttonClassName}
              type="submit"
              disabled={sendRegister.isLoading || sendLogin.isLoading}
            >
              {sendRegister.isLoading || sendLogin.isLoading
                ? "Creando cuenta..."
                : "Crear cuenta"}
            </button>
          </form>

          <p className="register-footer">
            ¿Ya tienes una cuenta? <a href="/login">Inicia sesión</a>
          </p>
      </div>
    </div>
  );
}
